import { AxiosResponse } from 'axios'

import { CompanyGroup } from 'types/group'

import { _axios } from './axios'

const ALL = `/groups`
const FIND_BY_ID = (id: string) => `/groups/${id}`
const ADD = `/groups`
const EDIT = (id: string) => `/groups/${id}`
const AddCompany = (id: string) => `/groups/${id}/companies`
const DeleteCompany = (id: string, companyId: string) =>
  `/groups/${id}/companies/${companyId}`

export const groupApi = () => {
  const getAll = async (): Promise<AxiosResponse<CompanyGroup[]>> => {
    return await _axios()
      .get(ALL)
      .then((res) => {
        res.data = res.data.companyGroups
        return res
      })
  }

  const findById = async (id: string): Promise<AxiosResponse<CompanyGroup>> => {
    return await _axios()
      .get(FIND_BY_ID(id))
      .then((res) => {
        res.data = res.data.companyGroup
        return res
      })
  }

  const add = async (
    data: Omit<CompanyGroup, 'id' | 'deletedAt'>,
  ): Promise<AxiosResponse<CompanyGroup[]>> => {
    return await _axios()
      .post(ADD, data)
      .then((res) => {
        res.data = res.data
        return res
      })
  }

  const edit = async (
    id: string,
    data: Omit<CompanyGroup, 'id'>,
  ): Promise<AxiosResponse<CompanyGroup[]>> => {
    return await _axios()
      .put(EDIT(id), data)
      .then((res) => {
        res.data = res.data
        return res
      })
  }

  const addCompany = async (
    id: string,
    companyIds: string[],
  ): Promise<AxiosResponse<CompanyGroup>> => {
    return await _axios()
      .post(AddCompany(id), { companyIds })
      .then((res) => {
        res.data = res.data.companyGroup
        return res
      })
  }

  const removeCompany = async (
    id: string,
    companyId: string,
  ): Promise<AxiosResponse<CompanyGroup>> => {
    return await _axios()
      .delete(DeleteCompany(id, companyId))
      .then((res) => {
        res.data = res.data.companyGroup
        return res
      })
  }

  return {
    getAll,
    findById,
    add,
    edit,
    addCompany,
    removeCompany,
  }
}
